<template>
  <div>
    <div class="row mt-4">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            Show&nbsp;
            <b-form-select
              v-model="perPageSummary"
              size="sm"
              :options="pageOptions"
            ></b-form-select
            >&nbsp;entries
          </label>
        </div>
      </div>
      <!-- Search -->
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_filter" class="dataTables_filter text-md-right">
          <label class="d-inline-flex align-items-center">
            Search:
            <b-form-input
              v-model="filter"
              type="search"
              placeholder="Search..."
              class="form-control form-control-sm ml-2"
            ></b-form-input>
          </label>
        </div>
      </div>
      <!-- End search -->
    </div>

    <div class="table-responsive mb-0">
      <b-table
        :items="tableData"
        :fields="fields"
        responsive="sm"
        :per-page="perPageSummary"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-compare="tableSort"
        :filter="filter"
        :filter-included-fields="filterOn"
      >
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPageSummary"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { tableSort } from '../../helper/helpers.js';
import firebase from 'firebase';

export default {
  name: 'ReportsPDF',
  components: {},
  props: {
    tableData: Array,
    fields: Array,
  },
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      perPageSummary: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'name',
      sortDesc: false,
      currentUser: this.$store.state.custom.currentUserData,
    };
  },
  methods: {
    setTableSettings: function () {
      if (this.currentUser.tablePageLengths) {
        if (this.currentUser.tablePageLengths.perPage_employeeHoursSummary) {
          this.perPageSummary =
            this.currentUser.tablePageLengths.perPage_employeeHoursSummary;
        }
      }
    },
    tableSort: tableSort,
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },
  },
  watch: {
    perPageSummary(newVal, oldVal) {
      this.currentUser = this.$store.state.custom.currentUserData;
      let oldCurrentUserPerPage = null;

      if (newVal !== oldVal) {
        let currentUserDataCopy = JSON.parse(JSON.stringify(this.currentUser));
        if (currentUserDataCopy.tablePageLengths) {
          if(currentUserDataCopy.tablePageLengths.perPage_employeeHoursSummary){
            oldCurrentUserPerPage = currentUserDataCopy.tablePageLengths.perPage_employeeHoursSummary;
          }
          currentUserDataCopy.tablePageLengths['perPage_employeeHoursSummary'] =
            newVal;
        } else {
          currentUserDataCopy['tablePageLengths'] = {
            perPage_employeeHoursSummary: newVal,
          };
        }

        // prevent a write after page render
        if (
          oldCurrentUserPerPage !== newVal
        ) {
          firebase
            .firestore()
            .collection('employees')
            .doc(this.currentUser.auth)
            .update({
              tablePageLengths: currentUserDataCopy.tablePageLengths,
            });
        }
        this.currentUser = currentUserDataCopy;
        this.$store.dispatch('custom/updateUserData', currentUserDataCopy);
      }
    },
  },
  mounted: function () {
    this.setTableSettings();
  },
};
</script>

<style scoped></style>
